<div class="edit-user">
    <dx-form id="form" #formRef [formData]="activeUser" labelLocation="top" [minColWidth]="300" (onFieldDataChanged)="onFieldDataChanged($event)">
        <dxi-item itemType="group" cssClass="first-group" caption="User Information" colCount="2">
            <dxi-item id="firstName" dataField="firstName" [disabled]="isFormDisabled" [editorOptions]="dxItemEditorOptions">
                <dxi-validation-rule type="required" message="First Name is required"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="100" message="First name is too long"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="lastName" [disabled]="isFormDisabled" [editorOptions]="dxItemEditorOptions">
                <dxi-validation-rule type="required" message="Last Name is required" ></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="100" message="Last name is too long"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="email" [disabled]="disableEmail" [editorOptions]="dxItemEditorOptions">
                <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                <dxi-validation-rule type="email" message="Email address is invalid, please enter a valid email address."></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="100" message="Email is too long"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="jobTitle" [disabled]="isFormDisabled" [editorOptions]="dxItemEditorOptions">
                <dxi-validation-rule type="stringLength" [max]="100" message="Job title is too long"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="hireDate" [disabled]="isFormDisabled" editorType="dxDateBox" [editorOptions]="dxItemEditorOptions"></dxi-item>
            <dxi-item dataField="employeeId" [disabled]="isFormDisabled" [editorOptions]="dxItemEditorOptions">
                <dxo-label text="Employee ID"></dxo-label>
                <dxi-validation-rule type="stringLength" [max]="100" message="Employee ID be less than 100 characters"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="ssoNameId" [disabled]="isFormDisabled" [editorOptions]="dxItemEditorOptions">
                <dxo-label text="SSO Name ID"></dxo-label>
                <dxi-validation-rule type="stringLength" [max]="100" message="SSO Name ID is too long"></dxi-validation-rule>
                <dxi-validation-rule type="pattern" [pattern]="ssoNameIdPattern" message="Please enter a valid SSO Name ID. SSO Name ID can only contain alphabets, numbers and/or any of these special characters ( @ * ( ) _ - \\ / . )"></dxi-validation-rule>
            </dxi-item>
            <dxi-item
                dataField="userRole.roleName"
                editorType="dxSelectBox"
                [disabled]="isFormDisabled"
                [editorOptions]="userRoleEditorOptions()">
                <dxo-label text="User Role"></dxo-label>
                <dxi-validation-rule type="required" message="User role is required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="isNonSSOUser" *ngIf="!isLoginMethodNone()" editorType="dxSelectBox" [disabled]="isFormDisabled" [editorOptions]="ssoUserEditorOptions()">                
                <dxo-label text="SSO User"></dxo-label>
            </dxi-item>
            <dxi-item *ngIf="!isLoginMethodNone()"
                itemType="empty" 
                [colSpan]="1">
            </dxi-item>
            
            <dxi-item itemType="group" cssClass="status-group" [colCount]="3" [colSpan]="2" caption="Status">
                <dxi-item dataField="isActive" editorType="dxSelectBox" [editorOptions]="statusEditorOptions()" [disabled]="isFormDisabled">            
                    <dxo-label text="Status"></dxo-label>
                </dxi-item>
                <dxi-item dataField="upsertStatus" [template]="'upsertStatusTemplate'">
                    <dxo-label text="Sync Status"></dxo-label>
                </dxi-item>
                <dxi-item dataField="lastSuccessfulLoginDate" [template]="'lastLoginTemplate'">
                    <dxo-label text="Last Login"></dxo-label>
                </dxi-item>
                <dxi-item dataField="isLockedOut" [disabled]="!isEditing" editorType="dxCheckBox" 
                    *ngIf="isEditing" [editorOptions]="{ onValueChanged: onIsLockedOutChanged }">
                    <dxo-label [text]="isLockedOutLabelText" location="left"></dxo-label>  
                </dxi-item>
                <dxi-item dataField="isDormant" [disabled]="!isEditing" editorType="dxCheckBox" 
                    *ngIf="isEditing && isShowDormant">
                    <dxo-label location="left"></dxo-label>
                </dxi-item>
                <dxi-item dataField="shouldResetPassword" [disabled]="!isEditing" editorType="dxCheckBox" 
                    *ngIf="isEditing && (isLoginMethodNone() || activeUser.isNonSSOUser)">
                    <dxo-label location="left" text="Force Password Reset"></dxo-label>
                </dxi-item>
            </dxi-item>
            
        </dxi-item>
        <div *dxTemplate="let data of 'upsertStatusTemplate'">
            <mat-icon *ngIf="activeUser.upsertStatus" class="status material-icons-outlined icon-sync-status-success">check_circle</mat-icon>
            <mat-icon *ngIf="!activeUser.upsertStatus" class="status material-icons-outlined icon-sync-status-error">error_outline</mat-icon>
        </div>
        <div *dxTemplate="let data of 'lastLoginTemplate'">
            <span class="label">{{ activeUser.lastSuccessfulLoginDate | date :'MM/dd/yyyy h:mm:ss a' }} </span>
        </div>
    </dx-form>
    <form [formGroup]="formGroup" class="legacy-form" *ngIf="_userAdminService.ClientsWithApplications?.length > 0">
        <div class="form-group">
            <span class="subtitle">Clients</span>
            <ng-container *ngFor="let client of _userAdminService.ClientsWithApplications">
                <input #newUserApp [formControlName]="getClientControlName(client.client.id)"
                    [id]="getClientControlName(client.client.id)"
                    (change)="onClientCheckChanged(newUserApp, client.client.id)" type="checkbox">
                <label for="abc">{{ client.client.name }}</label>
                <br />
            </ng-container>
            <div>
                <br />
            </div>
            <div class="form-group" *ngIf="_userAdminService.UserClients?.length > 0">
                <div *ngFor="let client of _userAdminService.UserClients; let cIndex = index">
                    <div *ngIf="_userAdminService && 
                                _userAdminService.ClientsWithApplications && 
                                _userAdminService.ClientsWithApplications.length > 0 && 
                                _userAdminService.ClientsWithApplications[client.index] && 
                                _userAdminService.ClientsWithApplications[client.index].clientApplications">
                        <div>
                            <span class="subtitle">Applications for {{client.client.name}}</span>
                            <div class="form-group">
                                <fieldset *ngIf="anyActiveClientApplications(client.client.id)">
                                    <legend> Active</legend>
                                    <div *ngFor="let application of applications; let ind= index ">
                                        <div
                                            *ngFor="let clientAppModel of _userAdminService.ClientsWithApplications[client.index].clientApplications;">
                                            <div
                                                *ngIf="application.id == clientAppModel.applicationId
                                                && clientAppModel.isActive && clientAppModel.isPurchased
                                                && application.id != 0 && checkUserApplicationMappingStatus(clientAppModel.clientId, application.id)">
                                                <label class="compact application list"
                                                    for="{{'applicationId' + ind + client.id}}">
                                                    <input #newUserApp
                                                        [formControlName]="getApplicationControlName(client.client.id, application.id)"
                                                        [id]="getApplicationControlName(client.client.id, application.id)"
                                                        (change)="userApplicationChecked(newUserApp, undefined, clientAppModel, cIndex)"
                                                        [value]="application.id" type="checkbox"
                                                        [checked]="isApplicationChecked(clientAppModel)">
                                                    {{ application.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <div *ngIf="!anyActiveClientApplications(client.client.id)">
                                    <label>No active applications</label>
                                </div> 
                                <fieldset
                                    *ngIf="anyInactiveClientApplications(client.client.id) &&
                                            _userAdminService && _userAdminService.ClientsWithApplications &&
                                            _userAdminService.ClientsWithApplications.length > 0 && 
                                            _userAdminService.ClientsWithApplications[client.index] && 
                                            _userAdminService.ClientsWithApplications[client.index].clientApplications">
                                    <legend>Pending</legend>
                                    <div *ngFor="let application of applications; let ind= index ">
                                        <div
                                            *ngFor="let clientAppModel of _userAdminService.ClientsWithApplications[client.index].clientApplications;">
                                            <div
                                                *ngIf="application.id == clientAppModel.applicationId && 
                                                !clientAppModel.isActive && 
                                                clientAppModel.isPurchased && 
                                                application.id != 0 && checkUserApplicationMappingStatus(clientAppModel.clientId, application.id)">
                                                <label class="compact application list"
                                                    for="{{'pendingApplicationId' + ind}}">
                                                    <input #newUserApp
                                                        [formControlName]="getApplicationControlName(client.client.id, application.id)"
                                                        [id]="getApplicationControlName(client.client.id, application.id)"
                                                        (change)="userApplicationChecked(newUserApp, undefined, clientAppModel, cIndex)"
                                                        [value]="application.id" type="checkbox"
                                                        [checked]="isApplicationChecked(clientAppModel)">
                                                    {{ application.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form> 

    <div class="end-padding"></div>
</div>